import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import {
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import {
  MatFormField,
  MatHint,
  MatInput,
  MatLabel,
} from '@angular/material/input';

@Component({
  selector: 'app-rejection-dialog',
  templateUrl: './rejection-dialog.component.html',
  styleUrl: './rejection-dialog.component.css',
  standalone: true,
  imports: [
    MatInput,
    FormsModule,
    MatDialogActions,
    MatDialogClose,
    MatDialogTitle,
    MatDialogContent,
    MatFormField,
    MatLabel,
    MatButton,
    MatHint,
  ],
})
export class RejectionDialogComponent {
  public comment: string = '';

  readonly dialogRef = inject(MatDialogRef<RejectionDialogComponent>);

  constructor() {}
}
